<img *ngIf="tenantId === 'INCY'" style="margin-bottom: 1px" src="/assets/images/logos/incyte.svg" />
<img *ngIf="tenantId === 'GLD'" class="text-black" src="/assets/images/logos/galderma.svg" />
<img *ngIf="tenantId === 'ALM'" style="margin-bottom: 0.3rem" src="/assets/images/almirall-logo.png" />
<img *ngIf="tenantId === 'BHC'" style="margin-bottom: 1px" src="/assets/images/bausch-health-logo.png" />
<img *ngIf="tenantId === 'DMO'" style="margin-bottom: 0.3rem" src="/assets/images/demo-tenant-logo.png" />
